<div
    class="px-1 py-2 vstack text-white"
>
    <div
        class="hstack gap-4 justify-content-between fs-3"
    >
        <span class="fw-semibold">
            {{ viewModel.startDate | dateTime : environment.assumedVenueTimeZone : DateTime.TIME_24_SIMPLE }}
            -
            {{ viewModel.endDate | dateTime : environment.assumedVenueTimeZone : DateTime.TIME_24_SIMPLE }}
        </span>
        @if (viewModel.serviceStatus !== null) {
            <app-service-status-badge
                [serviceStatus]="viewModel.serviceStatus"
                variant="title-and-icon"
                appearance="dark"
            >
            </app-service-status-badge>
        } @else {
            <div class="hstack gap-1">
                <img
                    *ngIf="viewModel.conditionIconPath"
                    [ngSrc]="viewModel.conditionIconPath"
                    width="16"
                    height="16"
                    alt="Booking status icon"
                />
                <span class="fw-semibold">
                    {{ viewModel.conditionName }}
                </span>
            </div>
        }
    </div>
    <div
        class="pt-2 vstack gap-2 fs-2 hidden-if-empty"
    >
        <div class="vstack gap-1 hidden-if-empty">
            @if (viewModel.expiryDate) {
                <div
                    class="hstack gap-2"
                >
                    <img
                        ngSrc="assets/clock/normal_white.svg"
                        width="16"
                        height="16"
                    />
                    <span class="text-truncate">
                        Expires {{ viewModel.expiryDate | dateTime : environment.assumedVenueTimeZone : DateTime.DATETIME_SHORT }}
                    </span>
                </div>
            }
            <div
                class="hstack gap-2"
            >
                <img
                    ngSrc="assets/person/normal_white.svg"
                    width="16"
                    height="16"
                />
                <span class="text-truncate">
                    <div class="hstack gap-1">
                        {{ viewModel.name }}
                        @if (viewModel.showVip) {
                            <div
                                class="hstack gap-2"
                            >
                                <img
                                    ngSrc="assets/vip/normal.svg"
                                    width="16"
                                    height="16"
                                />
                                <span class="text-truncate">
                                    VIP
                                </span>
                            </div>
                        }
                    </div>
                </span>
            </div>
            <div
                *ngIf="viewModel.showCustomerNote"
                class="hstack gap-2"
            >
                <div
                    class="d-block"
                    style="width: 16px; height: 16px;"
                >
                </div>
                <span class="text-truncate fw-semibold">
                    {{ viewModel.customerNote }}
                </span>
            </div>
            <div
                *ngIf="viewModel.dietaryRestrictions"
                class="hstack gap-2"
            >
                <img
                    ngSrc="assets/dietary-restrictions/small.svg"
                    width="16"
                    height="16"
                />
                <span class="text-truncate fw-semibold">
                    {{ viewModel.dietaryRestrictions }}
                </span>
            </div>
            <div
                *ngIf="viewModel.showEmailAddress"
                class="hstack gap-2"
            >
                <img
                    ngSrc="assets/email/normal_white.svg"
                    width="16"
                    height="16"
                />
                <span class="text-truncate">
                    {{ viewModel.emailAddress }}
                </span>
            </div>
            <div
                *ngIf="viewModel.showPhoneNumber"
                class="hstack gap-2"
            >
                <img
                    ngSrc="assets/phone/normal_white.svg"
                    width="16"
                    height="16"
                />
                <span class="text-truncate">
                    {{ viewModel.phoneNumber | phoneNumber }}
                </span>
            </div>
            <div
                *ngIf="viewModel.reasonName"
                class="hstack gap-2"
                [style.margin-left.px]="1"
            >
                <span class="badge-xs" translate="no">
                    {{ viewModel.reasonName.substring(0, 1) }}
                </span>
                <span class="text-truncate">
                    {{ viewModel.reasonName }}
                </span>
            </div>
            <div
                *ngIf="viewModel.requiresWheelchairAccess"
                class="hstack gap-2"
            >
                <img
                    ngSrc="assets/wheelchair/normal_small_white.svg"
                    width="16"
                    height="16"
                />
                <span class="text-truncate">
                    Wheelchair access required
                </span>
            </div>
            @if (viewModel.requiresDogFriendly) {
                <div
                    class="hstack gap-2"
                >
                    <img
                        ngSrc="assets/dog/normal_small_light.svg"
                        width="16"
                        height="16"
                    />
                    <span class="text-truncate">
                        Dog friendly seating required
                    </span>
                </div>
            }
            @if (viewModel.requiresPramAccessible) {
                <div
                    class="hstack gap-2"
                >
                    <img
                        ngSrc="assets/pram/normal_small_light.svg"
                        width="16"
                        height="16"
                    />
                    <span class="text-truncate">
                        Pram accessible seating required
                    </span>
                </div>
            }
            @if (viewModel.requiresHighchairFriendly) {
                <div
                    class="hstack gap-2"
                >
                    <img
                        ngSrc="assets/highchair/normal_small_light.svg"
                        width="16"
                        height="16"
                    />
                    <span class="text-truncate">
                        Highchair friendly seating required
                    </span>
                </div>
            }
            @let firstQuestionWithAnswer = viewModel.firstQuestionWithAnswer;
            @if (firstQuestionWithAnswer) {
                <div
                    class="hstack gap-1 align-items-start"
                >
                    <img
                        ngSrc="assets/question/normal_small_white.svg"
                        width="16"
                        height="16"
                    />
                    <div class="vstack">
                        <span
                            class="line-clamp-4"
                            [style.white-space]="'pre-wrap'"
                        >
                            {{ firstQuestionWithAnswer.question | slice:0:50 }}<span *ngIf="firstQuestionWithAnswer.question.length > 50">...</span>
                        </span>
                        <span
                            class="line-clamp-4 fw-semibold"
                            [style.white-space]="'pre-wrap'"
                        >
                            {{ firstQuestionWithAnswer.answer | slice:0:50 }}<span *ngIf="firstQuestionWithAnswer.answer.length > 50">...</span>
                        </span>
                    </div>
                </div>
            }
            <div
                *ngIf="viewModel.showCustomerNotes"
                class="hstack gap-2"
            >
                <img
                    ngSrc="assets/message/normal_white.svg"
                    width="16"
                    height="16"
                />
                <span
                    class="line-clamp-4"
                    [style.white-space]="'pre-wrap'"
                >{{ viewModel.customerMessage }}</span>
            </div>
            <div
                *ngIf="viewModel.showMerchantNotes"
                class="hstack gap-2"
            >
                <img
                    ngSrc="assets/tag/normal_white.svg"
                    width="16"
                    height="16"
                />
                <span
                    class="line-clamp-4"
                    [style.white-space]="'pre-wrap'"
                >{{ viewModel.merchantNotes }}</span>
            </div>
            <div
                *ngIf="viewModel.showDeposit"
                class="hstack gap-2 align-items-start"
            >
                <img
                    ngSrc="assets/cash/normal_white.svg"
                    width="16"
                    height="16"
                />
                <div class="vstack gap-1 text-start">
                    <span class="text-truncate">
                        Deposit held:
                        {{ null | currencyUnit : viewModel.depositAmountHeld : viewModel.depositCurrencyCode }}
                    </span>
                    <span
                        *ngIf="viewModel.depositAmountPending > 0"
                        class="text-truncate"
                    >
                        Deposit pending:
                        {{ null | currencyUnit : viewModel.depositAmountPending : viewModel.depositCurrencyCode }}
                    </span>
                </div>
            </div>
            <div
                *ngIf="viewModel.showPaymentCard"
                class="hstack gap-2"
            >
                <img
                    ngSrc="assets/credit-card/normal_white.svg"
                    width="16"
                    height="16"
                />
                <span class="text-truncate">
                    <span
                        *ngIf="viewModel.hasCardDetails"
                    >
                        Card details on file
                    </span>
                    <span
                        *ngIf="viewModel.isPendingCardDetails"
                    >
                        Waiting for card details
                    </span>
                </span>
            </div>
            <div
                *ngIf="viewModel.tooltipOrderSummary as tooltipOrderSummary"
                class="hstack gap-2"
            >
                <img
                    [ngSrc]="viewModel.hasPaidOrder ? 'assets/tag/normal_white.svg' : 'assets/food-drink/white.svg'"
                    width="16"
                    height="16"
                />
                <span class="text-truncate">
                    {{ tooltipOrderSummary }}
                </span>
            </div>
            @if (viewModel.utmSource && viewModel.source === BookingSource.Customer) {
                <div
                    class="hstack gap-2"
                >
                    <div
                        *ngIf="viewModel.hasCustomUtmSourceColor"
                        class="status-bar utm-source"
                        [style.background-color]="viewModel.utmSourceColor"
                    ></div>
                    <img
                        *ngIf="!viewModel.hasCustomUtmSourceColor"
                        ngSrc="assets/tag/normal_white.svg"
                        width="16"
                        height="16"
                    />
                    <span class="text-truncate">
                        Source: 
                        <span class="fw-semibold">
                            {{ viewModel.utmSource.toLocaleLowerCase() === 'rwg' ? 'Google' : viewModel.utmSource }}
                        </span>
                    </span>
                </div>
            }
        </div>
            <hr class="m-0 border-dark-subtle opacity-25" />
        <div
            class="vstack gap-1 hidden-if-empty"
        >
            <div
                class="hstack gap-2"
            >
                <img
                    ngSrc="assets/clock/normal_white.svg"
                    width="16"
                    height="16"
                />
                <span class="text-truncate">
                    Booked {{ viewModel.dateCreated | dateTime : environment.assumedVenueTimeZone : DateTime.DATETIME_SHORT }}
                </span>
            </div>
            <div
                *ngIf="viewModel.showHasAcknowledgedEndTime"
                class="hstack gap-2"
            >
                <img
                    ngSrc="assets/confirmed/outline_white.svg"
                    width="16"
                    height="16"
                />
                <span class="text-truncate">
                    End time acknowledged
                </span>
            </div>
            @if (viewModel.showLockedToTables) {
                <div
                    class="hstack gap-2"
                >
                    <img
                        ngSrc="assets/locked/normal_small_white.svg"
                        width="16"
                        height="16"
                    />
                    <span class="text-truncate">
                        Locked to {{ viewModel.allTableNames }}
                    </span>
                </div>
            }
        </div>
    </div>
</div>
